<template>
    <ul class="projects-list">
        <li v-for="post in posts" class="projects-list__item" :class="{
            'project-list__item--in-progress' : isInProgress(post.fields.project_status),
            'project-list__item--review' : isInReview(post.fields.project_status),
            'projects-list__item--featured' : post.fields.featured === true
        }">
            <div class="box" :class="{
            'box--cover': post.fields.project_image_size === 'cover',
            'box--contain': post.fields.project_image_size === 'contain'
            }">
                <a class="box__link" :href="post.link">

                    <div class="badges">

                        <div class="badges__badge badges__badge--in-progress"
                             v-if="isInProgress(post.fields.project_status)">
                            <span class="badges__badge-text badges__badge-text--in-progress">
                                {{i18n.inProgress}}
                        </span>
                        </div>

                        <div class="badges__badge badges__badge--review" v-if="isInReview(post.fields.project_status)">
                            <span class="badges__badge-text badges__badge-text--review">
                                {{i18n.inReview}}
                        </span>
                        </div>

                    </div> <!-- /.badges-->

                    <div class="box__image-wrap">
                        <blurry-image
                                class="box__image"
                                :smallImage="post.fields.project_image['48x38']"
                                :largeImage="post.fields.project_image['584x408']"
                                :alt="post.title.rendered"
                        >
                        </blurry-image>

                    </div>

                    <h2 class="box__title" v-html="post.title.rendered">
                    </h2>
                </a> <!-- /.box-->
            </div>
        </li>
    </ul> <!-- /.projects-list-->
</template>

<script>
    import blurryImage from './blurry-image.vue';

    export default {
        name: 'list',
        components: {
            blurryImage
        },
        props: {
            posts: {
                type: Array,
                required: true,
            }
        },
        data() {
            return {
                i18n: window.WP.i18n
            }
        },
        methods: {
            isInProgress(status) {
                return status.indexOf('in_progress') !== -1;
            },
            isInReview(status) {
                return status.indexOf('in_review') !== -1;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// list.vue?3c256f97